export class PayMemoExport {
    group: string;
    peopleSoftId: string;
    name: string;
    projectedPay: string;
    adjustments: string;
    adjustedProdPay: string;
    comments: string;
}
